import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const CheckPlusSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#9D95FF"
      fillRule="evenodd"
      d="M7.611 14.38 20.105 1.887 18.972.755 7.61 12.116 2.015 6.521.883 7.653 7.61 14.38h.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default CheckPlusSVG;
